module.exports = __webpack_public_path__ + "img/index_per.a403ab13.png";